var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiatorsHeatPumps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-30{fill:#fad184;}.cls-31{fill:#ecd39e;}.cls-32{fill:#f07662;}.cls-33{fill:#ebebeb;}.cls-34{fill:#eaeaea;}.cls-35{fill:#e9e9e9;}.cls-36{fill:#e9d09c;}.cls-37{fill:#ebd29d;}.cls-38{fill:#f5cb7f;}.cls-39{fill:#fee3aa;}.cls-40{fill:#ead19d;}.cls-41{fill:#f39889;}.cls-42{fill:#ee7561;}.cls-43{fill:#ececec;}.cls-44{fill:#fefefe;}.cls-45{fill:#fbdca1;}.cls-46{fill:#e5e5e5;}.cls-47{fill:#efefef;}.cls-48{fill:#e4e7ef;}.cls-49{fill:#90a6be;}.cls-50{fill:#cf6655;}.cls-51{fill:#d06755;}.cls-52{fill:#adb5c1;}.cls-53{fill:#ccc;}.cls-54{fill:#d36856;}.cls-55{fill:#d26756;}.cls-56{fill:#4068b5;}.cls-57{fill:#438f98;}.cls-58{fill:#4a535a;}.cls-59{fill:#375b9e;}.cls-60{fill:#385da1;}.cls-61{fill:#385ca0;}.cls-62{fill:#385b9f;}.cls-63{fill:#4a9ca6;}.cls-64{fill:#4a9da7;}.cls-65{fill:#448f99;}.cls-66{fill:#44909a;}.cls-12{clip-path:url(#clippath-13);}.cls-13{clip-path:url(#clippath-14);}.cls-14{clip-path:url(#clippath-12);}.cls-15{clip-path:url(#clippath-11);}.cls-16{clip-path:url(#clippath-18);}.cls-17{clip-path:url(#clippath-19);}.cls-18{clip-path:url(#clippath-17);}.cls-19{clip-path:url(#clippath-16);}.cls-20{clip-path:url(#clippath-10);}.cls-21{clip-path:url(#clippath-15);}.cls-22{clip-path:url(#clippath-25);}.cls-23{clip-path:url(#clippath-22);}.cls-24{clip-path:url(#clippath-23);}.cls-25{clip-path:url(#clippath-24);}.cls-26{clip-path:url(#clippath-21);}.cls-27{clip-path:url(#clippath-20);}.cls-28{mask:url(#mask);}.cls-67{fill:#fff;fill-rule:evenodd;}.cls-29{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.37,30.38c-1.46-.84-2.64-2.88-2.63-4.56-.37.22-.75.44-1.12.65,0,1.67,1.17,3.72,2.63,4.56.34-.2.79-.46,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.62,27.95c-.08.05-.18.03-.28-.03-.33.19-.66.38-.99.58l-.13.08c.1.06.2.07.28.03.34-.2.79-.46,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.34,27.92c-.33-.19-.66-.84-.32-1.05l-1.12.65c-.34.21-.01.86.32,1.05.34-.2.79-.46,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.74,25.82c0-.83.3-1.41.77-1.69l-1.12.65c-.47.27-.77.86-.77,1.69.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.24,30.56c-.48.28-1.14.24-1.87-.18l-1.12.65c.73.42,1.39.46,1.87.18.34-.2.79-.46,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.5,28.6l1.12-.65s.08-.07.11-.13l-1.12.65c-.03.06-.07.1-.11.13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.22,30.29c-.37.22-.75.44-1.12.65-.16.35-.39.62-.67.79l1.12-.65c.29-.17.52-.43.67-.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.25,23.42c-.39-.05-.75.02-1.04.19l-1.12.65c.29-.17.65-.24,1.04-.19.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.22,30.29c.04-.1.08-.2.11-.32-.37.22-.75.44-1.12.65-.03.11-.07.22-.11.32.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.25,23.42s-.03.02-.05.03c-.03.02-.06.03-.09.05-.04.03-.09.05-.13.08-.29.17-.57.33-.86.5.17.02.36.06.54.13.37-.22.75-.44,1.12-.65-.19-.07-.37-.11-.54-.13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.51,24.13l-1.12.65c.48-.28,1.15-.24,1.88.18l1.12-.65c-.73-.42-1.4-.46-1.88-.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.99,23.62c-.06-.03-.13-.05-.19-.08-.37.22-.75.44-1.12.65.06.02.13.05.19.08.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.17,23.71c-.06-.03-.12-.06-.18-.08-.37.22-.75.44-1.12.65.06.03.12.05.18.08.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.39,23.83c-.08-.04-.15-.08-.22-.12-.37.22-.75.44-1.12.65.07.04.15.08.22.12.34-.2.79-.46,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.44,23.86s-.04-.02-.05-.03l-1.12.65s.04.02.05.03c.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.12,31.21l1.12-.65c.47-.28.77-.86.77-1.7,0-1.67-1.17-3.71-2.63-4.55l-1.12.65c1.46.84,2.63,2.87,2.63,4.55,0,.83-.3,1.42-.77,1.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.44,29.11c0-.23-.02-.47-.06-.72-.37.22-.75.44-1.12.65.04.24.06.48.06.72,0,.32-.04.61-.11.87.37-.22.75-.44,1.12-.65.07-.26.11-.54.11-.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.19,24.42c-.24-.21-.49-.4-.75-.56-.37.22-.75.44-1.12.65.26.16.51.34.75.56.37-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.22,27.68c-.37.22-.75.44-1.12.65.07.24.12.48.16.71.37-.22.75-.44,1.12-.65-.04-.24-.09-.48-.16-.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.52,24.73c-.11-.11-.22-.22-.33-.32-.37.22-.75.44-1.12.65.11.1.22.21.33.32.38-.22.75-.44,1.12-.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.22,27.68c-.15-.52-.37-1.04-.65-1.52-.37.22-.75.44-1.12.65.28.49.5,1.01.65,1.52.29-.17.57-.33.86-.5.09-.05.18-.1.27-.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.52,24.73c-.37.22-.75.44-1.12.65.4.42.76.9,1.06,1.42.37-.22.75-.44,1.12-.65-.3-.52-.65-1.01-1.05-1.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.17,34.85l-.68.4c.24-.14.58-.12.96.09l.68-.4c-.38-.22-.71-.24-.96-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.39,38.52l.68-.4c.24-.14.39-.44.39-.86,0-.85-.6-1.9-1.34-2.32l-.68.4c.74.43,1.34,1.47,1.34,2.32,0,.42-.15.72-.39.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.76,32.95l-.68.4c.24-.14.58-.12.96.09l.68-.4c-.38-.22-.71-.24-.96-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.98,36.63l.68-.4c.24-.14.39-.44.39-.86,0-.85-.6-1.9-1.34-2.32l-.68.4c.74.43,1.34,1.47,1.34,2.32,0,.42-.15.72-.39.86Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 59.65,
    y: 85.8,
    width: 6.22,
    height: 14.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-67",
    points: "59.65 85.8 65.88 85.8 65.88 100 59.65 100 59.65 85.8"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CH_Boiler"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m62.03,60.22c0,.82.2,1.62.57,2.38.42.9,1.09,1.74,1.96,2.51,3.27,2.93,9.36,4.89,16.35,4.89s13.08-1.96,16.34-4.89c.87-.77,1.54-1.61,1.96-2.51.38-.76.57-1.56.57-2.38,0-5.4-8.45-9.79-18.87-9.79s-18.88,4.39-18.88,9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m62.03,12.48v3.67c0,.68.16,1.34.47,1.97.35.75.91,1.45,1.63,2.08,2.71,2.43,7.77,4.06,13.56,4.06s10.85-1.63,13.56-4.06c.72-.63,1.28-1.34,1.63-2.08.31-.63.47-1.3.47-1.97v-3.67c0,.63-.14,1.24-.4,1.83t0,0c-1.61,3.6-7.83,6.28-15.26,6.28s-13.65-2.68-15.26-6.28h0c-.26-.59-.4-1.21-.4-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m62.03,58.21v3.67c0,.68.16,1.34.47,1.97.35.75.91,1.45,1.63,2.08,2.71,2.43,7.77,4.06,13.56,4.06s10.85-1.63,13.56-4.06c.72-.63,1.28-1.34,1.63-2.08.31-.63.47-1.3.47-1.97v-3.67c0,.63-.14,1.24-.4,1.83t0,0c-1.61,3.6-7.83,6.28-15.26,6.28s-13.65-2.68-15.26-6.28h0c-.26-.59-.4-1.21-.4-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m62.03,12.48c0,.63.14,1.24.4,1.83h0c1.61,3.6,7.83,6.28,15.26,6.28s13.65-2.68,15.26-6.28t0,0c.26-.59.4-1.2.4-1.83,0-2.79-2.71-5.25-6.84-6.71v3.37c0,.1,0,.2-.02.3-.29,2.39-4.12,4.28-8.8,4.28s-8.51-1.89-8.8-4.28c-.01-.1-.02-.2-.02-.3v-3.37c-4.13,1.46-6.84,3.92-6.84,6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m68.87,4.23v4.91c0,2.52,3.95,4.57,8.82,4.57s8.82-2.05,8.82-4.57v-4.52c-.09-.03-.25,1.03-.27,1.06-.2.42-.51.81-.92,1.17-1.52,1.37-4.37,2.29-7.63,2.29s-6.11-.92-7.64-2.29c-.41-.36-.72-.75-.92-1.17-.09.03-.18-1.49-.27-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m62.03,15.24v44.39c0,4.48,7.01,8.12,15.66,8.12,8.65,0,15.66-3.63,15.66-8.12V15.24c0,.68-.16,1.34-.47,1.97-.35.75-.91,1.45-1.63,2.08-2.71,2.43-7.76,4.06-13.56,4.06s-10.85-1.63-13.56-4.06c-.72-.63-1.28-1.34-1.63-2.08-.31-.63-.47-1.3-.47-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m68.87,4.58c0,.38.09.76.27,1.11.2.42.51.81.92,1.17,1.53,1.37,4.38,2.29,7.64,2.29s6.11-.92,7.63-2.29c.41-.36.72-.75.92-1.17.18-.36.27-.73.27-1.11,0-2.52-3.95-4.58-8.82-4.58s-8.82,2.05-8.82,4.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m67.25,31.03l1.12-.65c-.23-.13-.45-.29-.66-.48l-1.12.65c.21.18.43.35.66.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m66.59,30.55l1.12-.65c-.28-.24-.54-.53-.77-.84l-1.12.65c.23.31.5.6.77.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m65.81,29.71l1.12-.65c-.58-.76-1-1.69-1.14-2.58l-1.12.65c.15.88.57,1.81,1.14,2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m64.67,27.14l1.12-.65c-.04-.22-.06-.45-.06-.66,0-.12,0-.23.02-.34l-1.12.65c-.01.11-.02.22-.02.34,0,.22.02.44.06.66"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m67.5,28.6l1.12-.65c-.08.04-.17.03-.26-.02l-1.12.65c.09.05.19.06.26.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m67.23,28.58l1.12-.65s-.01,0-.02,0l-1.12.65s.01,0,.02,0"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m67.22,28.57l1.12-.65s-.07-.05-.11-.08l-1.12.65s.07.06.11.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m67.11,28.49l1.12-.65c-.05-.04-.1-.1-.14-.16l-1.12.65c.04.06.09.11.14.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m66.96,28.34l1.12-.65c-.1-.13-.18-.29-.2-.44l-1.12.65c.02.15.1.3.2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m66.76,27.9l1.12-.65s-.01-.1,0-.14l-1.12.65s0,.09,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m66.76,27.76l1.12-.65s.01-.08.03-.11l-1.12.65s-.03.07-.03.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m66.79,27.64l1.12-.65s.06-.09.11-.12l-1.12.65c-.05.03-.09.07-.11.12"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m64.67,27.14l1.12-.65c-.04-.22-.06-.45-.06-.66,0-.12,0-.23.02-.34l-1.12.65c-.01.11-.02.22-.02.34,0,.22.02.44.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m64.63,26.13l1.12-.65c.03-.28.1-.52.2-.73l-1.12.65c-.1.21-.17.45-.2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m64.83,25.4l1.12-.65c.13-.27.32-.48.55-.61l-1.12.65c-.23.13-.42.34-.55.61"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m69.12,31.21l1.12-.65c-.46.26-1.08.24-1.77-.12l-1.12.65c.69.37,1.31.39,1.77.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m67.35,31.09l1.12-.65s-.07-.04-.11-.06l-1.12.65s.07.04.11.06"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m67.5,28.6l1.12-.65s.08-.07.11-.13l-1.12.65c-.03.06-.07.1-.11.13"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m69.42,31.73l1.12-.65c.27-.16.49-.4.64-.72l-1.12.65c-.15.32-.37.56-.64.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m70.06,31.01l1.12-.65c.12-.24.2-.53.23-.85l-1.12.65c-.04.33-.12.61-.23.85"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.14,24.41l1.12-.65c-.8-.43-1.53-.45-2.06-.14l-1.12.65c.53-.31,1.25-.28,2.06.14"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m70.06,31.01l1.12-.65c.12-.24.2-.53.23-.85l-1.12.65c-.04.33-.12.61-.23.85"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.14,24.41l1.12-.65c-.8-.43-1.53-.45-2.06-.14l-1.12.65c.53-.31,1.25-.28,2.06.14"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "68.27 26.83 69.4 26.18 68.02 26.87 66.9 27.52 68.27 26.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "67.61 28.47 68.73 27.82 69.4 26.18 68.27 26.83 67.61 28.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m68.27,26.83l-1.38.69c-.34.21-.01.86.32,1.05.15.09.3.08.39-.1l.67-1.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m67.26,24.97l1.12-.65s-.07-.04-.11-.06l-1.12.65s.07.04.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m67.16,24.91l1.12-.65c-.69-.37-1.32-.39-1.77-.13l-1.12.65c.46-.27,1.08-.24,1.77.13"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.14,24.41l1.12-.65c-.8-.43-1.53-.45-2.06-.14l-1.12.65c.53-.31,1.25-.28,2.06.14"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.14,24.41l1.12-.65c-.8-.43-1.53-.45-2.06-.14l-1.12.65c.53-.31,1.25-.28,2.06.14"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m67.26,24.48l1.12-.65s-.08-.05-.12-.07l-1.12.65s.08.05.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.14,24.41l1.12-.65c-.8-.43-1.53-.45-2.06-.14l-1.12.65c.53-.31,1.25-.28,2.06.14"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m68.03,25.03l1.12-.65c-.24-.21-.5-.4-.76-.55l-1.12.65c.26.15.52.34.76.55"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m69.12,31.21l1.12-.65c.23-.13.42-.34.55-.62l-1.12.65c-.13.27-.32.48-.55.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m69.67,30.6l1.12-.65c.1-.21.17-.45.2-.74l-1.12.65c-.03.28-.1.53-.2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m69.87,29.86l1.12-.65c.01-.11.02-.22.02-.34,0-.22-.02-.44-.06-.66l-1.12.65c.04.23.06.45.06.66,0,.12,0,.23-.02.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m69.83,28.85l1.12-.65c-.14-.88-.56-1.81-1.14-2.57l-1.12.65c.57.76.99,1.69,1.14,2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m68.7,26.29l1.12-.65c-.23-.31-.49-.59-.77-.84l-1.12.65c.28.24.54.53.77.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m67.92,25.45l1.12-.65c-.21-.18-.43-.35-.66-.48l-1.12.65c.23.13.45.29.66.48"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m70.06,31.01l1.12-.65c.12-.24.2-.53.23-.85l-1.12.65c-.04.33-.12.61-.23.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m70.29,30.16l1.12-.65c.01-.13.02-.26.02-.4,0-.25-.02-.51-.06-.77l-1.12.65c.04.26.06.52.06.77,0,.14,0,.27-.02.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m68.93,26.01l1.12-.65c-.27-.36-.57-.69-.9-.97l-1.12.65c.32.28.62.61.9.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m68.03,25.03l1.12-.65c-.24-.21-.5-.4-.76-.55l-1.12.65c.26.15.52.34.76.55"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m70.29,30.16l1.12-.65c.01-.13.02-.26.02-.4,0-.25-.02-.51-.06-.77l-1.12.65c.04.26.06.52.06.77,0,.14,0,.27-.02.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m70.25,29l1.12-.65c-.17-1.03-.66-2.1-1.32-2.99l-1.12.65c.67.89,1.16,1.96,1.32,2.99"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m68.93,26.01l1.12-.65c-.27-.36-.57-.69-.9-.97l-1.12.65c.32.28.62.61.9.97"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m69.89,29.52c0,1.67-1.19,2.35-2.64,1.51s-2.64-2.88-2.63-4.56,1.19-2.34,2.65-1.5,2.63,2.87,2.63,4.55Zm-2.67-.94c.15.09.3.08.39-.1l.67-1.64-1.38.69c-.34.21-.01.86.32,1.05"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m70.25,29l1.12-.65c-.17-1.03-.66-2.1-1.32-2.99l-1.12.65c.67.89,1.16,1.96,1.32,2.99"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m70.25,29l1.12-.65c-.17-1.03-.66-2.1-1.32-2.99l-1.12.65c.67.89,1.16,1.96,1.32,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m68.93,26.01l1.12-.65c-.27-.36-.57-.69-.9-.97l-1.12.65c.32.28.62.61.9.97"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m70.31,29.76c0,1.95-1.38,2.73-3.07,1.76s-3.06-3.35-3.06-5.29,1.38-2.72,3.08-1.75,3.06,3.34,3.05,5.28Zm-3.07,1.27c1.46.84,2.64.16,2.64-1.51s-1.17-3.71-2.63-4.55-2.64-.17-2.65,1.5,1.17,3.72,2.63,4.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m68.44,35.34l.68-.4c-.13-.07-.25-.12-.37-.15l-.68.4c.12.03.24.08.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m68.08,35.19l.68-.4c-.14-.04-.27-.04-.39-.02l-.68.4c.12-.02.25-.02.39.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m67.69,35.17l.68-.4c-.07.01-.14.04-.2.08l-.68.4c.06-.04.13-.06.2-.08"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m69.39,38.52l.68-.4c.24-.14.39-.44.39-.86,0-.12-.01-.24-.03-.37l-.68.4c.02.12.03.25.03.37,0,.42-.15.72-.39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m69.75,37.3l.68-.4c-.03-.18-.09-.37-.16-.56l-.68.4c.07.18.13.37.16.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m69.59,36.74l.68-.4c-.1-.25-.24-.5-.41-.72l-.68.4c.16.22.3.47.41.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m69.18,36.02l.68-.4c-.16-.21-.33-.39-.53-.54l-.68.4c.19.15.37.33.53.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m68.66,35.48l.68-.4c-.07-.05-.14-.1-.21-.14l-.68.4c.07.04.14.09.21.14"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 68.44,
    cy: 36.89,
    rx: 1.1,
    ry: 1.9,
    transform: "translate(-9.27 39.38) rotate(-30.16)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m64.03,33.44l.68-.4c-.13-.07-.25-.12-.37-.15l-.68.4c.12.03.24.08.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m63.67,33.29l.68-.4c-.14-.04-.27-.04-.39-.02l-.68.4c.12-.02.25-.02.39.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m63.28,33.27l.68-.4c-.07.01-.14.04-.2.08l-.68.4c.06-.04.13-.06.2-.08"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m64.98,36.63l.68-.4c.24-.14.39-.44.39-.86,0-.12-.01-.24-.03-.37l-.68.4c.02.12.03.25.03.37,0,.42-.15.72-.39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m65.34,35.4l.68-.4c-.03-.18-.09-.37-.16-.56l-.68.4c.07.18.13.37.16.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m65.18,34.84l.68-.4c-.1-.25-.24-.5-.41-.72l-.68.4c.16.22.3.47.41.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m64.77,34.12l.68-.4c-.16-.21-.33-.39-.53-.54l-.68.4c.19.15.37.33.53.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m64.25,33.58l.68-.4c-.07-.05-.14-.1-.21-.14l-.68.4c.07.04.14.09.21.14"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 64.03,
    cy: 34.99,
    rx: 1.1,
    ry: 1.9,
    transform: "translate(-8.91 36.91) rotate(-30.16)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-46",
    points: "58.2 93.93 58.2 52.57 68.66 47.24 68.66 88.67 58.2 93.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-53",
    points: "0 23.33 58.2 52.57 58.2 93.93 0 64.83 0 23.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-48",
    points: "68.66 47.24 10.39 18 0 23.33 58.2 52.57 68.66 47.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-52",
    d: "m43.58,50.15l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm3.5,1.77l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-24.21-12.02l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm3.5,1.77l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-24.21-12.05l1.42.76v32.98l-1.42-.62v-33.12Zm-3.22-1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-3.4-1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-3.43-1.66l1.42.76v32.98l-1.42-.62V31.34Zm-3.33-1.66l1.42.76v32.98l-1.42-.62V29.67Zm16.84,8.42l1.42.76v32.98l-1.42-.62v-33.12Zm3.5,1.77l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm31.8,12.89l-.09-.04L0,25.46v-.45l58.23,28.99,10.43-5.09v.45l-10.43,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-58",
    d: "m64.85,55.29c-.69-.25-1.56.44-1.95,1.54-.39,1.09-.15,2.18.54,2.43l1.41.6,1.9-3.58-1.9-.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-41",
    d: "m70.71,56.72l-3.06-1.34c-1.17-.42-2.62.65-3.24,2.38-.62,1.73-.17,3.47,1,3.89l3.06,1.34c1.17.42,2.62-.65,3.24-2.38.62-1.73.17-3.47-1-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-32",
    d: "m71.72,60.61c-.62,1.73-2.06,2.8-3.24,2.38-1.17-.42-1.62-2.16-1-3.89.62-1.73,2.07-2.8,3.24-2.38,1.17.42,1.62,2.16,1,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-58",
    d: "m64.73,46.2l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.7-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.42l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.63-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.25l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.6-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm49.1,67.98v2.6s.16,1.25,1.04.83l5.77-2.86s.67-.36.73-2.03v-2.18s-.05-1.2-1.2-.62l-5.35,2.6s-.99.57-.99,1.66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-32",
    d: "m60.3,85.8l3.6,1.94s2.02.95,1.97,2.94v8.13s.16,1.09-1.09,1.2c-1.25.1-1.04-1.09-1.04-1.09v-7.74s.02-.94-.8-1.35c-.81-.42-3.26-1.78-3.26-1.78,0,0-.24-1.7.61-2.23"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-49",
    d: "m63.9,83.93l3.79,2.03s2.03.95,1.97,2.94v8.13s.16,1.09-1.09,1.19c-1.25.1-1.04-1.09-1.04-1.09v-7.74s.02-.94-.8-1.35c-.81-.41-5.5-2.82-5.5-2.82,0,0,1.81-.76,2.66-1.29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiatorsHeatPumps);
export default __webpack_public_path__ + "static/media/radiators-heat-pumps.4a730ef701161a5dd0056a855dde8588.svg";
export { ForwardRef as ReactComponent };